module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/cases-dms.json
// module id = 477
// module chunks = 148423452425618